<template>
  <div v-if="item.children">
    <template v-if="item.children.length == 0">
      <el-menu-item :index="item.path">
        <i
          v-if="item.icon"
          class="iconfont"
          :class="item.icon"
          style="margin-right: 5px; font-size: 14px"
        ></i>
        <span slot="title">{{ item.title }}</span>
      </el-menu-item>
    </template>
    <el-submenu v-else :index="' ' + item.name">
      <template slot="title">
        <i
          v-if="item.icon"
          class="iconfont"
          :class="item.icon"
          style="margin-right: 5px; font-size: 14px"
        ></i>
        <span slot="title">{{ item.title }}</span>
      </template>
      <template v-for="child in item.children">
        <sidebar-item
          v-if="child.children && child.children.length > 0"
          :item="child"
          :key="child.path"
        />
        <el-menu-item v-else :key="child.path" :index="child.path">
          {{ child.title }}
        </el-menu-item>
      </template>
    </el-submenu>
  </div>
</template>

<script>
export default {
  name: "SidebarItem",
  props: ["item"],
};
</script>

<style scoped lang="scss">
.el-menu-item.is-active {
  background: #142944 !important;
}
.el-menu {
  border: none;
}
</style>